import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Button from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Button';

const styles = theme => ({
  root: {
    marginTop: theme.spacing(1),
  },
});

const CallbackButton = ({
  className,
  classes,
  label,
  onClick,
  ...rest
}) => {
  return (
    <Button
      className={classNames(classes.root, className)}
      variant={'contained'}
      disableElevation
      color={'primary'}
      onClick={onClick}
      {...rest}
    >
      {label}
    </Button>
  );
};

CallbackButton.defaultProps = {
  className: '',
  onClick: null,
};

CallbackButton.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  label: PropTypes.string.isRequired,
  onClick: PropTypes.func,
};

export default withStyles(styles)(CallbackButton);
